import { findAccessor } from './dom';
export const focusMaskClass = 'navigation-with-keyboard';
const rootEle = typeof document === 'object' ? document?.documentElement : undefined;
const bodyEle = typeof document === 'object' ? document?.body : undefined;
bodyEle?.addEventListener('keydown', () => {
    if (!rootEle?.classList.contains(focusMaskClass)) {
        rootEle?.classList.add(focusMaskClass);
    }
}, { capture: true });
bodyEle?.addEventListener('mousedown', (e) => {
    if (e.offsetX !== 0 && e.offsetY !== 0) {
        if (rootEle?.classList.contains(focusMaskClass)) {
            rootEle?.classList.remove(focusMaskClass);
        }
    }
}, { capture: true });
/**
 * Detect if an element is focusable and can be tabbed into.
 */
export function isFocusableElement(e) {
    // Consider merge this function with `./tabbable.ts`
    const tabIndex = e.getAttribute?.('tabindex');
    let focusable = false;
    if (!tabIndex) {
        if (e.tagName === 'A') {
            focusable = !!e.href;
        }
        else if (
        // There is also `<map>` which can be focusable actually. But this is not
        // easy to handle with and is rarely used. Ignore it here.
        ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON', 'OBJECT'].includes(e.tagName)) {
            focusable = !e.disabled;
        }
    }
    else {
        focusable = +tabIndex >= 0;
    }
    return (focusable &&
        window.getComputedStyle(e).visibility !== 'hidden' &&
        !findAccessor(e, (p) => window.getComputedStyle(p).display === 'none'));
}
/**
 * Find next focusable element in the order of DOM tree. i.e., the element to be focused as if the user press tab or shift-tab (when backward = true).
 */
export function findNextFocusableElement(current, backward) {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT);
    walker.currentNode = current;
    while (true) {
        const node = backward ? walker.previousNode() : walker.nextNode();
        if (!node) {
            return null;
        }
        if (isFocusableElement(node)) {
            return node;
        }
    }
}
function injectAriaStyle(element) {
    const { style } = element;
    style.position = 'absolute';
    style.top = '-1px';
    style.width = '1px';
    style.height = '1px';
    style.clip = 'rect(0,0,0,0)';
    style.borderWidth = '0';
    style.padding = '0';
    style.overflow = 'hidden';
    style.whiteSpace = 'nowrap';
}
/**
 * Make the screen reader announce an alert.
 */
export function triggerAriaMessage(message) {
    const alert = document.createElement('div');
    injectAriaStyle(alert);
    alert.role = 'alert';
    alert.ariaRoleDescription = ' ';
    alert.innerText = message;
    document.body.appendChild(alert);
    setTimeout(() => {
        document.body.removeChild(alert);
    }, 500);
}
/**
 * Make the a live area for screen readers which can be updated imperatively.
 */
export class LiveAnnouncer {
    constructor(isAssertive = false) {
        const live = document.createElement('div');
        injectAriaStyle(live);
        live.ariaLive = isAssertive ? 'assertive' : 'polite';
        live.ariaAtomic = 'true';
        document.body.appendChild(live);
        this.element = live;
    }
    update(message) {
        this.element.innerText = message;
    }
    destroy() {
        document.body.removeChild(this.element);
    }
}
